import app from "./appData";

const fetchContent = "/api/getContent/" + app.domain + "/";     // + page/isDashboard

export default {
    fetchContent,
}